import React from "react"

export default () => {
  return (
    <div className="contact">
      <p>
        Head office
        <br />
        33 George Street
        <br />
        Mount Eden, 1024
        <br />
        New Zealand
        <br />
      </p>
      <p>
        New Zealand & Australia sales
        <br />
        <br />
        Sophie Donovan
        <br />
        <a href="mailto:sales@katesylvester.com">→ sales@katesylvester.com</a>
      </p>
      <p>
        International sales
        <br />
        <br />
        Joseph Petchelco
        <br />
        Arddun Agency
        <br />
        <a href="mailto:joe@arddunagency.com">→ joe@arddunagency.com</a>
        <br />
        <a href="https://www.arddunagency.com">→ arddunagency.com</a>
      </p>
    </div>
  )
}
